// extracted by mini-css-extract-plugin
export default {"root":"root___RDPnj","title":"title___s6hlW","links":"links___UzFyG","link":"link___V2olK","icon_left":"icon_left___VzT5F","icon_right":"icon_right___PZwbN"};